import { EnrichmentPlugin, Event } from '@amplitude/analytics-types'
import { getEnv } from '@unni/platform'

class CommitIdPlugin implements EnrichmentPlugin {
  name = 'commit-log-plugin'
  type = 'enrichment' as const

  async setup(): Promise<void> {
    return undefined
  }

  async execute(event: Event): Promise<Event | null> {
    event.event_properties = {
      ...event.event_properties,
      commit_hash: getEnv('NEXT_PUBLIC_COMMIT_HASH'), // event 발생에 대한 commit hash를 추적할 수 있도록 합니다.
    }

    return event
  }
}

export default CommitIdPlugin
